export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  userInfo: {
    messages: [],  // {1: 'test', 2: 'test'}
    notifications: [],
    tasks: []
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js